import { withStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import classNames from 'classnames'

const styles = () => ({
  root: {
    '& > div > div > span ': {
      display: 'none',
    },
  },
})

const PrimaryTabs = ({ children, classes, onChange, value }) => (
  <Tabs className={classNames(classes.root)} value={value} onChange={onChange}>
    {children}
  </Tabs>
)

export default withStyles(styles)(PrimaryTabs)
